import * as React from "react";
import {Fragment} from "react";
import InboundTransactionRedemptionService
    from "../../../services/Transaction/inbound/InboundTransactionRedemptionService";
import SFXLoadingComponent from "../../SFXLoadingComponent";
import Card from "reactstrap/es/Card";
import SFXButtonComponent from "../../SFXButtonComponent";
import Row from "reactstrap/es/Row";
import Col from "reactstrap/es/Col";
import Input from "reactstrap/es/Input";
import Modal from "reactstrap/es/Modal";
import ModalHeader from "reactstrap/es/ModalHeader";
import ModalBody from "reactstrap/es/ModalBody";
import ModalFooter from "reactstrap/es/ModalFooter";
import * as QueryStringUtil from "../../../utils/QueryStringUtil";
import InboundTransactionService from "../../../services/Transaction/inbound/InboundTransactionService";
import ToastHelper from "../../../utils/ToastHelper";

export default class RedemptionLookupComponent extends React.Component {

    constructor(props) {
        super(props);

        if (props.quotationRef) {
            props.quotationRef(this);
        }

        this.state = {
            registrationId: this.props.registrationId,
            pin: "",
            redemptionResponse: {},
            loading: false,
            showQuotationErrorModal: false,
            quotationErrors: [],

            inValidFields: {},
            validFields: {}
        };
        this.props.setHeader()
    }

    componentDidMount() {
        let tokenFromUrl = QueryStringUtil.getQueryStringValue("t");
        if(tokenFromUrl !== undefined && tokenFromUrl !== null){
            InboundTransactionService.retrieveByToken(tokenFromUrl).then(response => {
                if (response.id) {
                    this.setState({
                        pin : response.collectionPin
                    }, this.redeem);
                } else if (response["error-code"] && response["error-code"] === "UNAUTHORIZED"){
                    ToastHelper.warning("Link is not valid or has expired.");
                }else{
                    ToastHelper.formatError(response);
                }
            });
        }
    }

    handleChange = (event, field) => {
        this.setState({
            pin: event.target.value
        });
    };

    redeem() {
        this.setState({
            loading: true,
        });

        InboundTransactionRedemptionService.lookup(this.props.registrationId, this.state.pin).then(response => {
            if (response.transactionId) {
                this.setState({
                    loading: this.props.continueLoading === undefined ? true : this.props.continueLoading,
                    redemptionResponse: response
                }, () => this.props.retrieveLookupResponse(response))
            } else {
                this.setState({
                    loading: false,
                    showErrorModal: true,
                    errors: response["message"]
                })
            }
        })
    }

    render() {

        if (this.state.loading)
            return <SFXLoadingComponent/>;

        return <Fragment>

            {this.props.className === 'mobile' ? this.renderRedemptionRequest('mobile') : this.renderBrowserRedemptionRequest('browser')}

        </Fragment>

    }

    renderRedemptionRequest(className) {

        return <Fragment>

            {this.renderErrorModal(className)}

            <div className={className + "_main_quotation_screen"}>
                {this.renderInput(className, "PIN", "Enter collection PIN")}
                {this.renderGetTransactionButton(className)}
            </div>

        </Fragment>

    }

    renderBrowserRedemptionRequest(className) {

        return <Card style={{
            boxShadow: "0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)",
            borderRadius: "15px",
            width: "55%",
            margin: "auto"
        }}>
            {this.renderRedemptionRequest(className)}
        </Card>
    }

    renderGetTransactionButton(className) {

        return <Fragment>
            {className === "browser" ? <br/> : <Fragment></Fragment>}
            <div className={className + "_register_button_div"}>
                <SFXButtonComponent
                    className={className + "_orange_oval_button"}
                    onClick={() => this.redeem()}
                    disabled={this.state.pin === ''}
                >Redeem</SFXButtonComponent>
            </div>
        </Fragment>
    }

    renderInput(className, field, text) {

        return <Fragment>

            <Row className={className + "_row"}>
                <Col>
                    <Input
                        className={className + "_input"}
                        value={this.state[field]}
                        placeholder={text}
                        onChange={(event) => this.handleChange(event, field)}
                    />
                    {this.state.inValidFields[field] && this.renderErrorMessage(className, field, this.state.inValidFields[field])}
                </Col>
            </Row>

        </Fragment>

    }

    renderErrorMessage(className, field, message) {
        return <h6 className={className + "_error_text"}>
            {message}
        </h6>;
    }

    renderErrorModal(className) {
        return <Modal isOpen={this.state.showErrorModal} className={'modal-danger modal-md'}>
            <ModalHeader className={className + "_modal_header modal-header"}>Invalid Input</ModalHeader>
            <ModalBody>
                {this.state.errors}
            </ModalBody>
            <ModalFooter>
                <SFXButtonComponent onClick={() => this.setState({showErrorModal: false})}>
                    Close
                </SFXButtonComponent>
            </ModalFooter>
        </Modal>
    }
}